import './index_web.css';
import { convertToDollars, RoundedOffAmount } from '../../utilities/helper';
import moment from 'moment';
import React from 'react';
import useTheme from '../../utilities/hooks/theme';

interface Props {
  item: any;
  creditType: any;
}

const TransactionEarningItemWeb = ({ item, creditType }: Props) => {
  const { AccountTheme: theme } = useTheme();

  const { amount = 0, createdOn = '', transactionType = '' } = item;

  const newAmount = RoundedOffAmount(amount);

  const statusColor = transactionType === 'debit' ? '#ff4b4b' : '#00ff47';
  const surfaceStyle = {
    border: `1px solid ${theme.transactionHistoryBorder}`
  };
  const col1Style = {
    background: theme.transactionHistoryDefaultColBg,
    boxShadow: theme.transactionHistoryDefaultColBoxShadow,
    borderRight: `1px solid ${theme.transactionHistoryBorder}`
  };
  const col2Style = {
    background: theme.transactionHistoryDefaultColBg,
    boxShadow: theme.transactionHistoryDefaultColBoxShadow,
    borderRight: `1px solid ${theme.transactionHistoryBorder}`
  };
  const col3Style = {
    background: theme.transactionHistoryDefaultCol3Bg,
    boxShadow: theme.transactionHistoryDefaultCol3BoxShadow
    // borderRight: `1px solid ${theme.transactionHistoryBorder}`
  };

  return (
    <>
      <div className="transactional_bonus_earning_table_cell" key={item._id} style={surfaceStyle}>
        <div className="transactional_bonus_earning_table_cell_col1" style={col1Style}>
          {' '}
          {createdOn ? moment(new Date(createdOn), 'YYYY-MM-DD').format('DD-MM-YYYY') : '-'}
        </div>
        <div className="transactional_bonus_earning_table_cell_col2" style={col2Style}>
          {' '}
          {createdOn ? moment(new Date(createdOn), 'HH:mm').format('HH:mm') : '-'}
        </div>
        <div className="transactional_bonus_earning_table_cell_col3" style={col3Style}>
          {/* {matchTitle && ( */}
          <p
            className="font_weight_800"
            style={{
              color: statusColor
            }}>
            {' '}
            {creditType}
          </p>
          {/* )} */}

          <p
            style={{
              color: statusColor
            }}>{`${transactionType === 'credit' ? '+' : '-'} ${convertToDollars(newAmount)}`}</p>
        </div>
      </div>
    </>
  );
};
export default React.memo(TransactionEarningItemWeb);
